import React, { Component } from "react";

// Mui
import {
  Grid,
  Paper,
  Select,
  MenuItem,
  TextField,
  Typography,
  Breadcrumbs,
  InputAdornment,
  FormGroup,
  FormControlLabel,
  Switch,
  Skeleton,
  Tooltip,
  Box,
  IconButton,
} from "@mui/material";
import { StyledSnackbar } from "../../common/AppSnackbar";

import FadeIn from "react-fade-in";
import { pageHeaderSx } from "../../../constants/pageLayout";
import Button from "@mui/material/Button";
import ReactJson from "react-json-view";
import {
  format,
  getFormattedDateFromUTC,
  print_timeline_date,
} from "../../../utils/Date";
import {
  AccountTree,
  BookRounded,
  OpenInFull,
  ArrowBack,
} from "@mui/icons-material";
import { send_request } from "../../../utils/Request";
import {
  loadDraftProject,
  loadPublishedProject,
} from "../../../utils/canvasApi";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import useProjectStore from "../../ProjectCanvas/useProjectStore";
import CancelPresentationIcon from "@mui/icons-material/CancelPresentation";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CrossCircleIcon from "@mui/icons-material/ErrorRounded";
import CachedRoundedIcon from "@mui/icons-material/CachedRounded";
import RemoveCircleRoundedIcon from "@mui/icons-material/RemoveCircleRounded";
import PauseCircleOutlineRoundedIcon from "@mui/icons-material/PauseCircleOutlineRounded";
import PendingIcon from "@mui/icons-material/Pending";
import Timeline from "@mui/lab/Timeline";
import TimelineItem from "@mui/lab/TimelineItem";
import TimelineContent from "@mui/lab/TimelineContent";
import TimelineOppositeContent from "@mui/lab/TimelineOppositeContent";
import TimelineSeparator from "@mui/lab/TimelineSeparator";
import TimelineConnector from "@mui/lab/TimelineConnector";
import ReplayIcon from "@mui/icons-material/Replay";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import {
  terminateMultipleSessions,
  updateTerminatedSessionsState,
  resumeAllPausedSessions,
} from "./SessionTerminationService";

dayjs.extend(utc);
dayjs.extend(timezone);

import "./LogStyling.css";
import { withParams } from "../../../Routes";
import config from "../../../config";
import { capitalizeLetter, getComponentDisplayName } from "./LogHelpers";

import SessionLogsTopBar from "./SessionLogsTopBar";
import SessionLogBox from "./SessionLogBox";
import SelectedSessionBox from "./SelectedSessionBox";
class ProjectLog extends Component {
  constructor(props) {
    super(props);

    this.state = {
      name: this.props.location.state
        ? this.props.location.state.project_name
        : "",
      data: [],
      rangeFilter: "LIST_ALL",
      statusFilter: [],
      rangeSelected: false,
      startTime: new Date(),
      EndTime: new Date(),
      selectedDate: new Date(),
      showAllLogDetails: false,
      expanded: {},
      expandAll: false,
      loading: false,
      checkId: "",
      sessionsShown: 0,
      sessionsAll: 0,
      projectId: "",
      refreshing: false,
      loadingScreen: true,
      currentPage: 0,
      sessionLogsTotal: 0,
      totalPage: 0,
      dataCurrentSize: 0,
      sessionLogsShown: 0,
      displayTestData: Boolean(
        this.props.location?.search?.includes("test=true")
      ),
      displayUnsubmittedData: Boolean(
        this.props.location.pathname.includes("unsubmittedForms")
      ),
      groupedFilteredRows: [],
      searchText: "",
      selectedSession: null,
      loadingMore: false,
      selectMode: false,
      selectedSessions: [],
      resumeResult: null,
    };

    this.refreshSessions.bind(this);
    this.containerRef = React.createRef();
  }

  renderFilters() {
    if (this.state.statusFilter.length === 0) {
      return [];
    } else {
      return this.state.statusFilter;
    }
  }

  mapStatusToName(status) {
    switch (status) {
      case "FAIL":
        return "Error";

      case "SUCCESS":
      case "SUCCESS_END":
        return "Success";

      case "INPROGRESS":
        return "In Progress";

      case "WAITING":
        return "Waiting";

      case "TERMINATED":
        return "Terminated";
      case "PAUSED":
        return "Paused";
    }
  }

  renderIcon = (status, size, largeFontSize) => {
    switch (status) {
      case "FAIL":
        return <CrossCircleIcon fontSize={size} className="cross-icon" />;

      case "PAUSED":
        return <PauseCircleOutlineRoundedIcon fontSize={size} color={"info"} />;
      case "SUCCESS":
      case "SUCCESS_END":
        return <CheckCircleIcon fontSize={size} className="check-icon" />;

      case "INPROGRESS":
        return (
          <CachedRoundedIcon fontSize={size} className="default-small-icon" />
        );

      case "WAITING":
        return <PendingIcon fontSize={size} className="small-yellow-icon" />;

      case "TERMINATED":
        return (
          <RemoveCircleRoundedIcon fontSize={size} className="small-red-icon" />
        );
      default:
        return <BookRounded fontSize={size} classname="default-small-icon" />;
    }
  };

  renderStatus = (displayUnsubmittedData, status, noStyling) => {
    const { classes } = this.props;
    let color;

    if (displayUnsubmittedData) {
      status = "From Session Saved";
    }
    if (!noStyling) {
      switch (status) {
        case "FAIL":
          color = "#B00020";
          break;
        case "SUCCESS":
        case "SUCCESS_END":
          color = "#31a633";
          break;
        case "INPROGRESS":
          color = "text.primary";
          break;
        case "WAITING":
          color = "#FF9D0B";
          break;
        case "TERMINATED":
          color = "#B00020";
          break;
        case "PAUSED":
          color = "info";
          break;
        case "From Session Saved":
          color = "grey";
          break;
      }
    }

    if (status === "FAIL") {
      status = "Error";
    }

    if (status === "INPROGRESS") {
      status = "In Progress";
    }

    return (
      <Box
        component="span"
        className={noStyling ? "statusStyling" : "statusBold"}
        sx={noStyling ? {} : { color }}
      >
        {capitalizeLetter(status.toLowerCase())}
      </Box>
    );
  };

  componentDidMount() {
    const { id } = this.props.params;

    if (id) {
      // Grab the search params
      const params = new URLSearchParams(this.props.location.search);
      const selectedSessionId = params.get("viewSession");

      // If we have a selected session, set it in the state accordingly
      if (selectedSessionId) {
        this.setState({
          selectedSession: {
            projectSessionId: selectedSessionId,
            projectId: id,
          },
        });
      }

      this.getSessionLogs(false);

      // Add scroll listener
      if (this.containerRef.current) {
        this.containerRef.current.addEventListener("scroll", this.handleScroll);
      }
    }
  }

  componentWillUnmount() {
    if (this.containerRef.current) {
      this.containerRef.current.removeEventListener(
        "scroll",
        this.handleScroll
      );
    }
  }

  loadMore = () => {
    this.getSessionLogs(true);
  };

  clearSearchText = (loadMore, displayTest) => {
    this.setState(
      { searchText: "", currentPage: 0, data: [], dataCurrentSize: 0 },
      () => {
        this.getSessionLogs(loadMore, displayTest);
      }
    );
  };

  doSearchLog = (displayTest, searchText) => {
    this.setState(
      { searchText: searchText, currentPage: 0, data: [], dataCurrentSize: 0 },
      () => {
        this.getSessionLogs(false, displayTest);
      }
    );
  };

  /**
   *
   * @param {*} switchedMode checks if the user has clicked on display test data
   */
  getSessionLogs = (
    loadMore,
    displayTestDataClicked = false,
    selectLatestSession = false
  ) => {
    if (loadMore) {
      this.setState({ loadingMore: true });
    } else {
      this.setState({ loadingScreen: true });
    }

    const { id } = this.props.params;
    let {
      currentPage,
      data,
      totalPage,
      dataCurrentSize,
      displayTestData,
      displayUnsubmittedData,
    } = this.state;

    const loadProject = useProjectStore.getState().production
      ? loadPublishedProject
      : loadDraftProject;

    loadProject(id).then((res) => {
      const projectData = res.data;
      if (projectData?.projectId) {
        let projectName = projectData.name;
        let extras = projectData.extras;

        let nextPage = 0;
        let updateCurrentData = false;

        if (loadMore) {
          if (totalPage === currentPage + 1) {
            nextPage = currentPage;
            updateCurrentData = true;
          } else {
            nextPage = currentPage + 1;
          }
        } else {
          nextPage = currentPage;
          updateCurrentData = true;
        }

        if (displayTestDataClicked || displayUnsubmittedData) {
          nextPage = 0;
          updateCurrentData = false;
          dataCurrentSize = 0;
          data = [];
        }

        let projectLogURL = `project-service/project/log/${id}/${nextPage}`;
        if (displayTestData) {
          projectLogURL = `project-service/test/log/${id}/${nextPage}`;
        } else if (displayUnsubmittedData) {
          projectLogURL = `project-service/project/unsubmittedFormLog/${id}`;
        }

        const requestBody = {};
        if (this.state.searchText) {
          requestBody["searchText"] = this.state.searchText;
        }

        send_request(
          projectLogURL,
          requestBody,
          displayUnsubmittedData ? {} : { returnHeadersOnly: true },
          Object.keys(requestBody).length === 0 ? "GET" : "POST"
        )
          .then((res) => {
            if (res && res.data) {
              if (updateCurrentData) {
                if (dataCurrentSize !== res.data.data.length) {
                  data = [];
                  for (let i = 0; i < res.data.data.length; i++) {
                    data.push(res.data.data[i]);
                  }
                } else {
                  data = res.data.data;
                }
              } else {
                data = data.concat(res.data.data);
              }

              let expanded = {};
              for (let i = 0; i < data.length; i++) {
                expanded[data[i].projectSessionId] = false;
              }
              const latestSessionData = data?.[0];
              const latestProjectSessionId =
                latestSessionData?.projectSessionId;

              this.setState({
                name: projectName,
                data: data,
                expandAll: false,
                expanded: expanded,
                projectId: id,
                loadingScreen: false,
                sessionLogsTotal: res.data.totalSessionLogs,
                currentPage: nextPage,
                totalPage: res.data.totalPage,
                dataCurrentSize: res.data.data.length,
                loadingMore: false,
                selectedSession:
                  latestProjectSessionId && selectLatestSession
                    ? {
                        projectSessionId: latestProjectSessionId,
                        projectId: id,
                        projectTestId: latestSessionData?.projectTestId,
                      }
                    : this.state.selectedSession,
              });
            }
          })
          .catch((err) => {
            this.setState({
              loadingScreen: false,
              loadingMore: false,
            });
            throw Error(err.message);
          });
      }
    });
  };

  refreshSessions = (
    displayTestDataClicked = false,
    selectLatestSession = false
  ) => {
    this.getSessionLogs(false, displayTestDataClicked, selectLatestSession);
  };

  handleToggleOne = (sessionId) => () => {
    let newExpanded = { ...this.state.expanded };
    newExpanded[sessionId] = !newExpanded[sessionId];
    this.setState({ expanded: newExpanded });
  };

  goBack = () => {
    this.props.navigate(`/project/canvas/${this.props.params.id}`);
  };

  renderPageHeader = () => {
    const projectTitle = this.state.name || this.props.params.id;

    return (
      <Paper
        elevation={0}
        className="fade-in project-log-header"
        sx={{
          ...pageHeaderSx,
          justifyContent: "space-between",
          px: 2,
          borderBottom: "1px solid",
          borderColor: "divider",
          backgroundColor: "background.paper",
          borderRadius: 0,
          position: "sticky",
          top: 0,
          zIndex: 1000,
          width: "100%",
          marginLeft: 0,
          marginRight: 0,
          marginTop: 0,
          pointerEvents: "auto",
          overflow: "hidden",
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            width: "100%",
            minWidth: 0,
            overflow: "hidden",
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              flexShrink: 0,
              mr: 1,
            }}
          >
            <IconButton
              size="small"
              onClick={this.goBack}
              sx={{
                mr: 0.5,
                p: 0.5,
              }}
            >
              <ArrowBack />
            </IconButton>

            {this.state.loadingScreen ? (
              <Skeleton
                variant="rectangular"
                sx={{
                  height: "20px",
                  width: "200px",
                  ml: 0.5,
                }}
              />
            ) : (
              <Typography
                variant="h6"
                component="h1"
                onClick={this.goBack}
                sx={{
                  fontSize: "1.1rem",
                  fontWeight: 500,
                  flexShrink: 0,
                  ml: 0.5,
                  maxWidth: "600px",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                  cursor: "pointer",
                  "&:hover": {
                    textDecoration: "underline",
                  },
                }}
              >
                {projectTitle}
              </Typography>
            )}
          </Box>
        </Box>
      </Paper>
    );
  };

  doSearch = (aRow) => {
    let result = false;
    if (aRow.components) {
      for (let a = 0; !result && a < aRow.components.length; a++) {
        let aComponent = aRow.components[a];
        if (aComponent.data) {
          result = this.doDataSearch(aComponent.data);
        }
      }
    }

    return result;
  };

  doDataSearch = (data) => {
    if (data && typeof data == "string") {
      //found the string
      return data.includes(this.state.filterInput);
    }

    if (data) {
      let keys = Object.keys(data);
      let result = false;
      for (let a = 0; !result && a < keys.length; a++) {
        result = this.doDataSearch(data[keys[a]]);
      }

      return result;
    }

    return false;
  };

  filterRecords = (classes) => {
    let filteredRows = this.state.data
      .sort((a, b) =>
        b.lastUpdated < a.lastUpdated
          ? -1
          : b.lastUpdated > a.lastUpdated
          ? 1
          : 0
      )
      .filter((aRow) => {
        let result = false;

        const difference = dayjs().diff(dayjs(aRow.lastUpdated));

        if (this.state.rangeFilter === "LAST_HOUR") {
          result = difference <= 3600000;
        } else if (this.state.rangeFilter === "LAST_DAY") {
          result = difference <= 86400000;
        } else if (this.state.rangeFilter === "LAST_WEEK") {
          result = difference <= 604800000;
        } else if (this.state.rangeFilter === "LIST_ALL") {
          result = true;
        } else if (this.state.rangeFilter === "SELECT_RANGE") {
          // smaller than start
          result =
            dayjs(aRow.lastUpdated) >= dayjs(this.state.startTime) &&
            dayjs(aRow.lastUpdated) <= dayjs(this.state.EndTime);
        }

        if (
          result &&
          this.state.filterInput &&
          this.state.filterInput.trim() != ""
        ) {
          result = this.doSearch(aRow);
        }

        // Checks the status of the record
        if (this.state.statusFilter.length >= 1) {
          return this.state.statusFilter.includes(aRow.status) && result;
        }

        return result;
      });

    if (this.state.sessionLogsShown != filteredRows.length) {
      this.setState({ sessionLogsShown: filteredRows.length });
    }

    filteredRows = this.groupLogsByDate(filteredRows);
    if (filteredRows.length === 0 && this.state.displayUnsubmittedData)
      return (
        <p className="noSubmittedFormsMessage">
          No unsubmitted forms sessions found for this workflow
        </p>
      );

    return (
      <Grid container>
        {filteredRows.map(({ date, logs }, groupIdx) => {
          if (logs === null) return;
          return this.getSessionLogRow(date, logs, classes, groupIdx);
        })}
      </Grid>
    );
  };

  getSessionLogRow = (date, logs, classes, groupIdx) => {
    return (
      <Grid container key={groupIdx}>
        <Grid item xs={12} className="sessionLogDate">
          {this.renderLogDate(date)}
        </Grid>
        <Grid item xs={12}>
          <Grid container spacing={2} className="responsiveGridContainer">
            {logs.map((row, rowIdx) => {
              return (
                <Grid item xs={12} key={`Group-${groupIdx}-Row-${rowIdx}`}>
                  <SessionLogBox
                    row={row}
                    index={rowIdx}
                    classes={classes}
                    renderIcon={this.renderIcon}
                    renderStatus={this.renderStatus}
                    displayTestData={this.state.displayTestData}
                    handleToggleOne={this.handleToggleOne}
                    expanded={this.state.expanded}
                    displayUnsubmittedData={this.state.displayUnsubmittedData}
                    selectedSession={this.state.selectedSession}
                    setSelectedSession={(item) =>
                      this.setState({ selectedSession: item })
                    }
                    selectMode={this.state.selectMode}
                    selectedSessions={this.state.selectedSessions}
                    onSelectSession={this.handleSelectSession}
                  />
                </Grid>
              );
            })}
          </Grid>
        </Grid>
      </Grid>
    );
  };

  renderLogDate = (date) => {
    const userTimezone = dayjs.tz.guess();
    const localDate = dayjs(date).tz(userTimezone);

    let dateText;
    if (this.isToday(localDate)) {
      dateText = "Today";
    } else if (this.isYesterday(localDate)) {
      dateText = "Yesterday";
    } else {
      dateText = print_timeline_date(localDate);
    }

    // Get the count of logs for this date from the grouped data
    const logsForDate = this.state.data.filter((log) => {
      const logDate = getFormattedDateFromUTC(
        log.lastUpdated,
        useProjectStore.getState().timezone
      );

      return logDate === date;
    }).length;

    return `${dateText} (${logsForDate} ${logsForDate === 1 ? "run" : "runs"})`;
  };

  isYesterday = (someDate) => {
    const userTimezone = dayjs.tz.guess();
    const yesterday = dayjs().tz(userTimezone).subtract(1, "day");

    return yesterday.isSame(someDate, "day");
  };

  isToday = (someDate) => {
    const userTimezone = dayjs.tz.guess();
    const today = dayjs().tz(userTimezone);

    return today.isSame(someDate, "day");
  };

  groupLogsByDate = (logs) => {
    logs = logs.filter((l) => l.lastUpdated !== null);

    const groups = logs.reduce((groups, log) => {
      let date;
      date = getFormattedDateFromUTC(
        log.lastUpdated,
        useProjectStore.getState().timezone
      );

      if (!groups[date]) {
        groups[date] = [];
      }
      groups[date].push(log);
      return groups;
    }, {});

    const groupArrays = Object.keys(groups).map((date) => ({
      date,
      logs: groups[date],
    }));

    const sorted = groupArrays.sort((a, b) => {
      return new Date(b.date) - new Date(a.date);
    });

    return sorted;
  };

  handleScroll = () => {
    if (this.state.loadingScreen) return;

    const container = this.containerRef.current;
    if (!container) return;

    const { scrollTop, scrollHeight, clientHeight } = container;

    // Check if we've scrolled near the bottom (within 100px)
    if (scrollHeight - scrollTop - clientHeight < 100) {
      if (this.state.data.length < this.state.sessionLogsTotal) {
        this.loadMore();
      }
    }
  };

  handleSelectSession = (sessionId) => {
    const { selectedSessions } = this.state;
    if (selectedSessions.includes(sessionId)) {
      this.setState({
        selectedSessions: selectedSessions.filter((id) => id !== sessionId),
      });
    } else {
      this.setState({
        selectedSessions: [...selectedSessions, sessionId],
      });
    }
  };

  setSelectMode = (mode) => {
    this.setState({ selectMode: mode });
    if (!mode) {
      this.setState({ selectedSessions: [] });
    }
  };

  handleTerminateSessions = async (sessionIds) => {
    if (!sessionIds || sessionIds.length === 0) return;

    this.setState({ loadingScreen: true });

    try {
      // Call the terminate API for each session
      await terminateMultipleSessions(sessionIds, this.state.displayTestData);

      // Update local state to reflect terminated sessions
      const updatedData = updateTerminatedSessionsState(
        this.state.data,
        sessionIds
      );

      this.setState({
        data: updatedData,
        selectedSessions: [],
        loadingScreen: false,
      });

      // Refresh the sessions to ensure we have the latest data
      this.refreshSessions(false, this.state.displayUnsubmittedData);
    } catch (error) {
      console.error("Error terminating sessions:", error);
      this.setState({ loadingScreen: false });
      // Optionally show an error notification to user
    }
  };

  handleResumeAllPaused = async () => {
    try {
      const result = await resumeAllPausedSessions(this.props.params.id);

      let message;
      if (result?.reason === "OUT_OF_QUOTA") {
        message =
          "Still out of session quota — nothing was resumed. Upgrade your plan or wait for your quota to reset.";
      } else {
        const count = result?.resumedSessions || 0;
        message = `Resumed ${count} paused session${count === 1 ? "" : "s"}.`;
      }

      this.setState({ resumeResult: message });
      this.refreshSessions(false, this.state.displayUnsubmittedData);
    } catch (error) {
      console.error("Error resuming paused sessions:", error);
      this.setState({
        resumeResult: "Failed to resume paused sessions. Please try again.",
      });
    }
  };

  handleDeleteUnsubmittedSessions = async (sessionIds) => {
    if (!sessionIds || sessionIds.length === 0) return;

    this.setState({ loadingScreen: true });

    try {
      const { id } = this.props.params;

      // Call the delete API
      await send_request(
        `project-service/project/unsubmittedFormSessions/${id}`,
        sessionIds,
        {},
        "DELETE"
      );

      // Remove deleted sessions from local state
      const updatedData = this.state.data.filter(
        (session) => !sessionIds.includes(session.projectSessionId)
      );

      this.setState({
        data: updatedData,
        selectedSessions: [],
        selectMode: false,
        loadingScreen: false,
        sessionLogsTotal: updatedData.length,
      });
    } catch (error) {
      console.error("Error deleting unsubmitted form sessions:", error);
      this.setState({ loadingScreen: false });
    }
  };

  render() {
    const { classes } = this.props;
    const project_id = window.location.pathname.split("/").pop();

    const getSessionLogPage = () => {
      return (
        <Grid container direction="row">
          <Grid item xs={this.state.selectedSession ? 3 : 12}>
            <Grid className="sessionLogsGrid" ref={this.containerRef}>
              <Grid container>
                <SessionLogsTopBar
                  refreshing={this.state.refreshing}
                  refreshSessions={(displayTest, displayUnsubmittedForms) =>
                    this.refreshSessions(displayTest, displayUnsubmittedForms)
                  }
                  searchLogs={(displayTest, searchText) =>
                    this.doSearchLog(displayTest, searchText)
                  }
                  clearSearchText={(displayTest) =>
                    this.clearSearchText(false, displayTest)
                  }
                  renderFilters={() => this.renderFilters()}
                  classes={classes}
                  mapStatusToName={this.mapStatusToName}
                  updateState={(updated) => this.setState(updated)}
                  logsShown={this.state.sessionLogsShown}
                  logsTotal={this.state.sessionLogsTotal}
                  rangeFilter={this.state.rangeFilter}
                  startTime={this.state.startTime}
                  endTime={this.state.EndTime}
                  displayTestData={this.state.displayTestData}
                  displayUnsubmittedform={this.state.displayUnsubmittedData}
                  loadMore={this.loadMore}
                  projectId={this.props.params.id}
                  searchText={this.state.searchText}
                  selectedSession={this.state.selectedSession}
                  loadingScreen={this.state.loadingScreen}
                  selectMode={this.state.selectMode}
                  setSelectMode={this.setSelectMode}
                  selectedSessions={this.state.selectedSessions}
                  setSelectedSessions={(sessions) =>
                    this.setState({ selectedSessions: sessions })
                  }
                  sessions={this.state.data}
                  onTerminateSessions={this.handleTerminateSessions}
                  onDeleteUnsubmittedSessions={
                    this.handleDeleteUnsubmittedSessions
                  }
                  onResumeAllPaused={this.handleResumeAllPaused}
                />

                {this.state.displayTestData && (
                  <Grid item xs={12} marginTop="24px">
                    <Grid
                      container
                      display="flex"
                      alignItems="center"
                      justifyContent="center"
                      className="testDataBanner"
                    >
                      <span className="testDataBannerText">Test sessions</span>
                    </Grid>
                  </Grid>
                )}

                {this.state.loadingScreen ? (
                  getSkeletonLoaders()
                ) : this.state.data ? (
                  this.filterRecords(classes)
                ) : (
                  <></>
                )}
              </Grid>
            </Grid>
          </Grid>
          {this.state.selectedSession && (
            <Grid item xs={9}>
              <SelectedSessionBox
                selectedSession={this.state.selectedSession}
                closeSelectedSession={() =>
                  this.setState({ selectedSession: null })
                }
                refreshSessions={this.refreshSessions}
                searchText={this.state.searchText}
              />
            </Grid>
          )}
        </Grid>
      );
    };

    const getSkeletonLoaders = () => {
      return (
        <Grid item xs={12} paddingTop="16px">
          <Grid container>
            {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((page, i) => {
              return (
                <Grid item xs={12} marginTop="8px" key={i}>
                  <Skeleton
                    variant="rectangular"
                    className="styledSkeleton"
                    style={{
                      height: "80px",
                      width: "100%",
                    }}
                  />
                </Grid>
              );
            })}
          </Grid>
        </Grid>
      );
    };

    return (
      <>
        {this.renderPageHeader()}
        {getSessionLogPage()}

        <StyledSnackbar
          open={this.state.loadingMore}
          message="Loading more sessions..."
          severity="info"
          loading
          hideClose
          autoHideDuration={null}
          onClose={() => {}}
        />

        <StyledSnackbar
          open={Boolean(this.state.resumeResult)}
          message={this.state.resumeResult || ""}
          severity="info"
          onClose={() => this.setState({ resumeResult: null })}
          autoHideDuration={6000}
        />
      </>
    );
  }
}

export default withParams(ProjectLog);
